/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryVersionResponse } from './RevisdomAPIViewModelsEntryVersionResponse';
import {
    RevisdomAPIViewModelsEntryVersionResponseFromJSON,
    RevisdomAPIViewModelsEntryVersionResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryVersionResponseToJSON,
    RevisdomAPIViewModelsEntryVersionResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryVersionResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryVersionListResponse
 */
export interface RevisdomAPIViewModelsEntryVersionListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryVersionResponse>}
     * @memberof RevisdomAPIViewModelsEntryVersionListResponse
     */
    items?: Array<RevisdomAPIViewModelsEntryVersionResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryVersionListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryVersionListResponse(value: object): value is RevisdomAPIViewModelsEntryVersionListResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryVersionListResponseFromJSON(json: any): RevisdomAPIViewModelsEntryVersionListResponse {
    return RevisdomAPIViewModelsEntryVersionListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryVersionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryVersionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RevisdomAPIViewModelsEntryVersionResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryVersionListResponseToJSON(json: any): RevisdomAPIViewModelsEntryVersionListResponse {
    return RevisdomAPIViewModelsEntryVersionListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryVersionListResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryVersionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RevisdomAPIViewModelsEntryVersionResponseToJSON)),
    };
}

